import { Page } from "../types/types";
import { API_URL } from "../utils/config";

export const getPage = (pageId: number): Promise<Page> => {
  return fetch(`${API_URL}/pages/${pageId}`).then((response) => {
    return response.json();
  });
};
